var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 50,
    viewBox: "0 0 130 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 23.4109V26.5647C127 37.4254 117.718 45.9667 106.895 45.0653L69.235 41.9289C66.142 41.6713 63.0924 41.0345 60.1547 40.0327L56.1626 38.6714C46.013 35.2104 34.8386 36.573 25.8182 42.3718L21.6016 45.0825C19.6543 46.3344 17.388 47 15.073 47C8.40528 47 3 41.5947 3 34.927V19.5C3 12.7466 8.048 7.05911 14.7536 6.25735L34.7853 3.86225C41.5754 3.0504 48.4366 4.62304 54.1952 8.31115L75.7443 22.1122C84.0772 27.449 95.208 23.5965 98.4588 14.2503C99.7604 10.5081 103.288 8 107.25 8H111.589C120.1 8 127 14.8997 127 23.4109Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack14);
export default __webpack_public_path__ + "static/media/track14.35eb4f5b.svg";
export { ForwardRef as ReactComponent };